module.exports = __webpack_public_path__ + "static/media/Adviesbox_BER.16b5d740.png";